function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { memo } from "react";
var SvgPlusReward = function SvgPlusReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Frame 3714804"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "url(#paint0_linear_11626_28569)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.5H15.125V19.5H12.875V7.5Z",
    fill: "#2A2A2A",
    style: _defineProperty(_defineProperty({
      fill: "#2A2A2A"
    }, "fill", "color(display-p3 0.1648 0.1648 0.1648)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.375V14.625L8 14.625L8 12.375L20 12.375Z",
    fill: "#2A2A2A",
    style: _defineProperty(_defineProperty({
      fill: "#2A2A2A"
    }, "fill", "color(display-p3 0.1648 0.1648 0.1648)"), "fillOpacity", 1)
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11626_28569",
    x1: 1.32722e-7,
    y1: 3.32702,
    x2: 27,
    y2: 23.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFEBA5"
    }, "stopColor", "color(display-p3 1.0000 0.9216 0.6471)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7804 0.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFE27B"
    }, "stopColor", "color(display-p3 1.0000 0.8863 0.4824)"), "stopOpacity", 1)
  }))));
};
var Memo = /*#__PURE__*/memo(SvgPlusReward);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/plus-reward.4bb8978804e02f5f94c4cf957a2fb6ac.svg";